module.exports = __webpack_public_path__ + "static/img/TRENT-TATTOLI.24db834.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TRENT-TATTOLI.jpg
// module id = 0Q2O
// module chunks = 0